import { render, staticRenderFns } from "./tabbar4.vue?vue&type=template&id=d0924980&scoped=true&"
import script from "./tabbar4.vue?vue&type=script&lang=js&"
export * from "./tabbar4.vue?vue&type=script&lang=js&"
import style0 from "./tabbar4.vue?vue&type=style&index=0&id=d0924980&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0924980",
  null
  
)

export default component.exports